var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDD551",
    d: "M3.993 8.497 0 15.827l4 .005c2.2.002 5.8.002 8 0l4-.005-3.993-7.33c-2.197-4.032-4-7.33-4.007-7.33-.007 0-1.81 3.298-4.007 7.33Zm3.42.674v2.27H8.587V6.902H7.412v2.27Zm0 4.19v.527H8.587v-1.054H7.412v.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.993 8.497 0 15.827l4 .004c2.2.003 5.8.003 8 0l4-.004-3.993-7.33c-2.197-4.032-4-7.33-4.007-7.33-.007 0-1.81 3.298-4.007 7.33Zm.983.65a1663.986 1663.986 0 0 0-3.02 5.557c-.005.02.995.024 6.044.024 4.985 0 6.05-.004 6.044-.023-.01-.037-6.033-11.09-6.044-11.09-.005 0-1.366 2.49-3.024 5.533Zm2.436.024v2.27h1.176V6.902H7.412v2.27Zm0 4.19v.527h1.176v-1.054H7.412v.527Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningFilled);
export default __webpack_public_path__ + "static/media/icon--warning-filled.ccb7a58afcc90c69d6e3dc901e8ebd5f.svg";
export { ForwardRef as ReactComponent };